import { SLUG_REGEX } from 'common/utils/regex'

interface Linkable {
  id: string
  useSlug: boolean
  slug: string
}

export const generateStageLink = (stage: Linkable) => generateLink(stage, 'stages', 'venues')
export const generateMusicianLink = (musician: Linkable) => generateLink(musician, 'musicians', 'artists')

export const generateLink = (linkable: Linkable, defaultPath: string, slugPath: string) =>
  linkable.useSlug && SLUG_REGEX.test(linkable.slug)
    ? `/${slugPath}/${linkable.slug}`
    : `/${defaultPath}/${linkable.id}`
